export class ResetPasswordRequest {
  public Email: string;
  public RecaptchaToken: string;
  constructor(email: string, token: string) {
    this.Email = email;
    this.RecaptchaToken = token;
  }
}
